import { BaseRequest, PagingRequest } from 'Services/base';
import { getQueryParamsForListAPI } from 'Services/api';

export class ListCustomSchemasRequest extends BaseRequest {
  constructor( pageParameters: PagingRequest ) {
    super( {
      method: 'GET',
      url: '/tenantservice/v1/custom-schemas',
      responseType: 'json',
      params: getQueryParamsForListAPI( pageParameters ),
    } );
  }
}
